import { createContext, useContext, useState, useEffect } from 'react';
import { useAnalyticsPushEvent } from '../../../analytic/analytic.context';
import bem from '../../../utils/bem';
import Button from '../../Atoms/Button';
import Icon from '../../Atoms/Icon/Icon';

const DropDownContext = createContext({
  open: false,
});

function DropDown({ children }) {
  const [open, toggle] = useState(false);

  return (
    <div className="m-dropdown">
      <DropDownContext.Provider value={{ open, toggle }}>
        {children}
      </DropDownContext.Provider>
    </div>
  );
}

function Toggle({ closedText, openedText, onOpenAnalytics }) {
  const pushAnalyticsEvent = useAnalyticsPushEvent();
  const { open, toggle } = useContext(DropDownContext);
  const iconClassName = bem('icon', [open && 'opened'], 'm-dropdown', []);

  useEffect(() => {
    if (open && onOpenAnalytics) {
      pushAnalyticsEvent(onOpenAnalytics);
    }
  }, [open]);

  return (
    <Button className="m-dropdown__btn" onClick={() => toggle?.(!open)}>
      {open ? openedText : closedText || openedText}
      <Icon
        className={iconClassName}
        iconName="chevron"
        width={16}
        height={16}
      />
    </Button>
  );
}

function Content({ children }) {
  const { open } = useContext(DropDownContext);
  return open ? <div className="m-dropdown__content">{children}</div> : null;
}

DropDown.Toggle = Toggle;
DropDown.Content = Content;

export default DropDown;
